/**
 * Конфигурация ставок
 */

export const BET_CONFIG = {
  min: 0.1,
  max: 100,
  step: 0.1,
  default: 0.1,
} as const;

export type BetConfig = typeof BET_CONFIG;
